<template lang="pug">
.container
  .tools-grid
    .tool-card(
      v-for="t in tools",
      v-if="$route.name === 'tools' && (!t.local || local)",
      :key="t.name",
      @click="goto(t.target)",
      :title="t.info"
    )
      .tool-image(:style="{ backgroundImage: 'url(' + t.img + ')' }")
      .tool-info
        h3 {{ t.name }}
        p {{ t.info }}
  router-view
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Icon from "@/components/Icon.vue";
import Button3d from "@/components/Button3d.vue";

export default {
  components: { Icon, Button3d },
  data() {
    return {
      local: false,
    };
  },
  computed: {
    ...mapGetters({
        tools: 'navi/items'
    })
  },
  methods: {
    ...mapActions({
      get_menu: "navi/menu"
    }),
    goto(t) {
      this.$router.push({ name: t });
    },
  },
  async created() {
    await this.get_menu({ area: 'tools' });
    this.local = window.location.protocol == "http:";
  },
};
</script>

<style lang="less" scoped>
.container {
  flex: 1 0;
  display: flex;
  flex-flow: column;
  padding: 0;
  overflow: auto;
  background: #f9f9fb;
}

h2 {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
}

.tool-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  cursor: pointer;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  text-align: center;
  padding: 1.5rem 1rem;
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.15);
  }

  &:active {
    transform: scale(0.98);
  }
}

.tool-image {
  width: 80px;
  height: 80px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 1rem;
}

.tool-info {
  h3 {
    margin: 0.3rem 0;
    font-size: 1.2rem;
    color: #222;
  }

  p {
    font-size: 0.9rem;
    color: #666;
    line-height: 1.3;
  }
}

@media screen and (max-width: 600px) {
  .container {
    padding: 0;
  }
  h2 {
    font-size: 1.4rem;
  }
  .tool-card {
    padding: 1rem;
  }
  .tool-image {
    width: 60px;
    height: 60px;
  }
}

</style>